<main class="page-body narrower">
  <mat-card
    appearance="outlined"
    class="top-progress center-content extra-padding extra-padding"
  >
    <h2>Woah there!</h2>

    <img
      class="img-figure"
      alt="We're Processing Your Waste Profile"
      width="400"
      src="/assets/access-denied.svg"
    />

    <p>
      It looks like you don't have access to that page.<br />
      If you believe this to be in error, please contact Republic Services.
    </p>
  </mat-card>
</main>
